import DataVDigitalFlop from './digital-flop';
export default DataVDigitalFlop;
